import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { Content } from '../models/content';
import { StepType } from '../models/stepType';

type TrainingContentResponse = {
  id: string;
  name: string;
  contentType: string;
  lastEditedDate: string;
  numberOfQuestions: number;
  published: boolean;
  owner: string;
  library: boolean;
};

const transformTrainingContent = (content: TrainingContentResponse) => ({
  ...content,
  type: content.contentType,
  questions: content.numberOfQuestions,
  lastModifiedDate: content.lastEditedDate,
});

export const getTrainingContent = (orgId: string, type: StepType): Promise<Content[]> => {
  const filterType = type === 'audio' ? 'video' : type;

  return cacheableRequest(`/v1/organizations/${orgId}/content`).then(
    (response: AxiosResponse<{ content: TrainingContentResponse[] }>) =>
      response?.data?.content.map(transformTrainingContent).filter(content => {
        if (type === 'documentViewer') {
          return content.type.toLowerCase() === 'download' && content.name.toLowerCase().endsWith('.pdf');
        }
        return content.type.toLowerCase() === filterType.toLowerCase();
      })
  );
};
